/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update a feature bundle
 * @export
 * @interface UpdateFeatureBundleRequest
 */
export interface UpdateFeatureBundleRequest {
    /**
     * Display name
     * @type {string}
     * @memberof UpdateFeatureBundleRequest
     */
    name?: string;
    /**
     * Optional description
     * @type {string}
     * @memberof UpdateFeatureBundleRequest
     */
    description?: string;
    /**
     * List of feature_id from feature_catalog
     * @type {Array<string>}
     * @memberof UpdateFeatureBundleRequest
     */
    featureIds?: Array<string>;
    /**
     * Sort order for display
     * @type {number}
     * @memberof UpdateFeatureBundleRequest
     */
    sortOrder?: number;
    /**
     * Whether the bundle is active
     * @type {boolean}
     * @memberof UpdateFeatureBundleRequest
     */
    active?: boolean;
    /**
     * Provider grantor tenant id, or null for platform catalog. Platform admin only. Phase E / ADR 0004.
     * @type {string}
     * @memberof UpdateFeatureBundleRequest
     */
    providerTenantId?: string;
    /**
     * How to update existing grants when bundle definition changes: SYNC_TO_BUNDLE, GRANDFATHER, NO_CHANGE
     * @type {string}
     * @memberof UpdateFeatureBundleRequest
     */
    bundleSyncPolicy?: string;
}

/**
 * Check if a given object implements the UpdateFeatureBundleRequest interface.
 */
export function instanceOfUpdateFeatureBundleRequest(value: object): value is UpdateFeatureBundleRequest {
    return true;
}

export function UpdateFeatureBundleRequestFromJSON(json: any): UpdateFeatureBundleRequest {
    return UpdateFeatureBundleRequestFromJSONTyped(json, false);
}

export function UpdateFeatureBundleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFeatureBundleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'featureIds': json['featureIds'] == null ? undefined : json['featureIds'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'active': json['active'] == null ? undefined : json['active'],
        'providerTenantId': json['providerTenantId'] == null ? undefined : json['providerTenantId'],
        'bundleSyncPolicy': json['bundleSyncPolicy'] == null ? undefined : json['bundleSyncPolicy'],
    };
}

export function UpdateFeatureBundleRequestToJSON(json: any): UpdateFeatureBundleRequest {
    return UpdateFeatureBundleRequestToJSONTyped(json, false);
}

export function UpdateFeatureBundleRequestToJSONTyped(value?: UpdateFeatureBundleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'featureIds': value['featureIds'],
        'sortOrder': value['sortOrder'],
        'active': value['active'],
        'providerTenantId': value['providerTenantId'],
        'bundleSyncPolicy': value['bundleSyncPolicy'],
    };
}

